import Handsontable from 'handsontable'
import CellValue = Handsontable.CellValue
import plugins = Handsontable.plugins
import LocationService from '@/services/LocationService'

export function AutofillCountries(
  instance: Handsontable,
  data: CellValue[][],
  coords: plugins.RangeType[]
) {
  const isCountries = coords[0].endCol === 0
  const { startRow, endRow } = coords[0]

  if (!isCountries) {
    return undefined
  }

  let currentRow = startRow
  let currentRowIndex = 0

  LocationService.getCountries().then(countries => {
    while (currentRow <= endRow) {
      const countryName: string = data[currentRowIndex][0].toLowerCase()
      const country = countries.find(c => c.name.toLowerCase() === countryName)
      const countryCellMeta = instance.getCellMeta(currentRow, 0)

      if (country) {
        countryCellMeta.valid = true

        instance.setDataAtRowProp(currentRow, 'country.id', country.id)
        instance.setDataAtRowProp(currentRow, 'country.name', country.name)
      } else {
        countryCellMeta.valid = false
      }

      currentRow++
      currentRowIndex++
    }

    instance.render()
  })
}
